import React from "react";
import { Link, useLocation } from "react-router-dom";
import "./Navbar.css";
const Navbar = () => {
    const location = useLocation();
    return (
        <nav className="navbar">
            <div className="nav-title">
                <Link to="/" className="nav-home-link">JONOON</Link>
            </div>
            <div className="nav-center">
                <ul className="nav-links">
                    <li className={location.pathname === "/" ? "active" : ""}><Link to="/">Home</Link></li>
                    <li className={location.pathname === "/about" ? "active" : ""}><Link to="/about">About</Link></li>
                    <li className={location.pathname === "/contact" ? "active" : ""}><Link to="/contact">Contact</Link></li>
                    <li className={location.pathname === "/ticket-check" ? "active" : ""}><Link to="/ticket-check">Ticket Check</Link></li>
                </ul>
            </div>
        </nav>
    );
};
export default Navbar;
